import React from "react";
import classNames from "classnames";

interface ToggleSwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange }) => {
    return (
        <button
            type="button"
            onClick={() => onChange(!checked)}
            className={classNames("w-12 h-6 flex items-center rounded-full p-1 transition-colors duration-300", checked ? "bg-blue-600" : "bg-gray-300")}
        >
            <div className={classNames("bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300", checked ? "translate-x-6" : "translate-x-0")} />
        </button>
    );
};

export default ToggleSwitch;
